import { getType } from "typesafe-actions";
import * as feedbackDisplayed from "./actions";
export var initialState = false;
export var feedbackDisplayedReducer = function feedbackDisplayedReducer(state, action) {
  if (state === void 0) {
    state = initialState;
  }

  switch (action.type) {
    case getType(feedbackDisplayed.hide):
      return false;

    case getType(feedbackDisplayed.display):
      return true;

    default:
      return state;
  }
};